import {gtZero} from '@shared/helpers/lang'

import {getSaleHistoryDetailByApi} from '@web/actions/saleHistory'
import {getInitialState, PaymentDetailItem, PaymentMethodDetailItem} from '@web/slices/orderPaymentDetail/slice'
import makeSlice from '@web/slices/orderPaymentDetail/sliceMaker'

const orderPaymentDetailSlice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(getSaleHistoryDetailByApi.pending, () => {
                return getInitialState()
            })
            .addCase(getSaleHistoryDetailByApi.fulfilled, (state, {payload}) => {
                const {
                    pay: {
                        easyPay,
                        escrowCommissionAmount,
                        rewardPointPayAmount,
                        chargePointPayAmount,
                        promotionApplyAmount,
                        payLaterAmount,
                        totalInitPayAmount,
                        totalProductAmount,
                        deliveryFeeAmount,
                        generalPayAmount,
                        generalPayMeansClassType,
                    },
                } = payload.detail

                state.summary = {
                    type: 'NORMAL',
                    amount: totalInitPayAmount,
                }

                const isFleaMarket = !!payload.detail.order.fleaMarketTradTalkChannelId

                const paymentDetailItems: PaymentDetailItem[] = [
                    {
                        type: isFleaMarket ? 'ESCROW_COMMISSION' : 'SAFETY_PURCHASE',
                        amount: escrowCommissionAmount,
                    },
                ]

                state.paymentDetail = {
                    title: '총 주문금액',
                    amount: totalInitPayAmount,
                    items: [
                        {type: 'PRODUCT', amount: totalProductAmount},
                        {type: 'SHIPPING', amount: deliveryFeeAmount},
                        ...paymentDetailItems.filter(({amount}) => amount && amount > 0),
                    ],
                    types: [],
                }

                const paymentMethodAmountItems: {
                    valid: boolean
                    data: PaymentMethodDetailItem
                }[] = [
                    {
                        valid: gtZero(promotionApplyAmount),
                        data: {
                            type: 'CARD_PROMOTION',
                            amount: promotionApplyAmount,
                        },
                    },
                    {
                        valid: gtZero(rewardPointPayAmount),
                        data: {
                            type: 'REWARD_POINT',
                            amount: rewardPointPayAmount,
                        },
                    },
                    {
                        valid: gtZero(chargePointPayAmount),
                        data: {
                            type: 'CHARGE_POINT',
                            amount: chargePointPayAmount,
                        },
                    },
                    {
                        valid: gtZero(payLaterAmount),
                        data: {
                            type: 'PAY_LATER',
                            amount: payLaterAmount,
                        },
                    },
                    {
                        valid: generalPayMeansClassType === 'BANK' || generalPayMeansClassType === 'BANK_EASY_PAY',
                        data: {
                            type: easyPay ? 'BANK_EASY_PAY' : 'BANK',
                            amount: generalPayAmount,
                            // 판매상세는 판매자 view 이므로, 주문상세에 노출되는 구매자가 이용한 은행은 노출하지 않음
                            value: {
                                status: 'SIMPLE',
                                transferBankName: '',
                                date: '',
                            },
                        },
                    },
                    {
                        valid: generalPayMeansClassType === 'VIRTUAL_ACCOUNT',
                        data: {
                            type: 'VIRTUAL_ACCOUNT',
                            amount: generalPayAmount,
                            // 판매상세는 판매자 view 이므로, 주문상세에 노출되는  무통장입금 안내 노출하지 않음
                            value: {
                                status: 'SIMPLE',
                                bankName: '',
                                id: '',
                                holderName: '',
                                payExpirationDate: '',
                            },
                        },
                    },
                ]
                state.paymentMethodDetail = {
                    items: paymentMethodAmountItems.filter(({valid}) => valid).map(({data}) => data),
                }
            })
    },
})

export default orderPaymentDetailSlice.reducer
